class AccountRegisterPanel extends Panel {
  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      window.trapFocus(this, this.defaultFocus, triggerElement, false);
    });
    if (previousPanel) {
      previousPanel.deactivate();
    }
  }
}
customElements.define('account-register-panel', AccountRegisterPanel);
